<template>
  <div class="inquiry_footer">
    <div class="inquiry_footer_one">
      <el-button size="small" icon="el-icon-menu" @click="toTerm" :type="$route.name === 'InquiryTerm' ? 'primary' : ''">保险产品</el-button>
    </div>
    <div class="inquiry_footer_one">
      <el-button size="small" icon="el-icon-chat-dot-round" @click="toHistory" :type="$route.name === 'InquiryIndex' ? 'primary' : ''">询价记录</el-button>
    </div>
    <div class="inquiry_footer_one">
      <el-button size="small" icon="el-icon-user" @click="toIndex">首页</el-button>
    </div>
  </div>
</template>

<script>
    export default {
        name: "InquiryFooter",
      mounted(){
          console.log(this.$route);
      },
      methods:{
        toIndex(){
          this.$router.push('/');
        },
        toTerm(){
          this.$router.push('/inquiry/term');
        },
        toHistory(){
          this.$router.push('/inquiry/index');
        }
      }
    }
</script>

<style scoped>
  .inquiry_footer {
    width:100%;
    background-color:white;
    height:4rem;
  }
  .inquiry_footer_one {
    float:left;
    text-align:center;
    width:25%;
    margin:0 4%;
    height:4rem;
    line-height:4rem;
    font-size:.8rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/inquiry/footer.vue